document.addEventListener('mouseover', (e) => {
  const swatchLink = e.target.closest('[data-swatch-hover-image]');
  if (!swatchLink) return;

  const gridItem = swatchLink.closest('product-grid-item');
  if (!gridItem) return;

  const activeWrapper = gridItem.querySelector(
    '.product-grid-item__image-wrapper.is-active'
  );
  const img = activeWrapper && activeWrapper.querySelector('img');
  if (!img) return;

  // Store originals once, so mouseleave can restore exactly
  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.src;
    img.dataset.originalSrcset = img.srcset || '';
  }

  const newSrc = swatchLink.getAttribute('data-swatch-hover-image');
  const newSrc2x = swatchLink.getAttribute('data-swatch-hover-image-2x');

  img.src = newSrc;
  img.srcset = newSrc2x ? `${newSrc} 1x, ${newSrc2x} 2x` : newSrc;
});

document.addEventListener('mouseout', (e) => {
  const swatchLink = e.target.closest('[data-swatch-hover-image]');
  if (!swatchLink) return;

  const gridItem = swatchLink.closest('product-grid-item');
  if (!gridItem) return;

  const activeWrapper = gridItem.querySelector(
    '.product-grid-item__image-wrapper.is-active'
  );
  const img = activeWrapper && activeWrapper.querySelector('img');
  if (!img || !img.dataset.originalSrc) return;

  img.src = img.dataset.originalSrc;
  img.srcset = img.dataset.originalSrcset;
});